import { render, staticRenderFns } from "./InvitationCode.vue?vue&type=template&id=5bd9ebd8&scoped=true"
import script from "./InvitationCode.vue?vue&type=script&lang=js"
export * from "./InvitationCode.vue?vue&type=script&lang=js"
import style0 from "./InvitationCode.vue?vue&type=style&index=0&id=5bd9ebd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd9ebd8",
  null
  
)

export default component.exports